export default __webpack_public_path__ + "static/media/517.3afa2833.png";